import { render, staticRenderFns } from "./CourseBox.vue?vue&type=template&id=67badfe3&scoped=true&"
import script from "./CourseBox.vue?vue&type=script&lang=js&"
export * from "./CourseBox.vue?vue&type=script&lang=js&"
import style0 from "./CourseBox.vue?vue&type=style&index=0&id=67badfe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67badfe3",
  null
  
)

export default component.exports